import { motion } from "framer-motion"
import styled from "styled-components/macro"
import Toggle from "./Toggle"

export const Menu = styled.nav`
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  top: ${({ isOpen }) => (isOpen ? 0 : "100%")};
  height: 100%;
  display: flex;
  user-select: none;
  overflow: hidden;
  transition: top 0.3s ease;
`

export const LinkGroup = styled.ul`
  z-index: 100;

  width: 100%;
  height: 100%;

  list-style-type: none;
  padding-left: 10vw;
  margin: 0;

  display: flex;
  align-items: center;

  background-color: ${({
    theme: {
      palette: { menuBG }
    }
  }) => menuBG};

  color: ${({
    theme: {
      palette: { menuFG }
    }
  }) => menuFG};
`

export const LinkItem = styled(motion.li)`
  z-index: 9999999999999;
  font-family: NewParisKingSize-Regular;
  font-weight: 100;
  font-size: 5vh;
  line-height: 8vh;
`

export const OpenToggle = styled(Toggle)`
  position: fixed;
`

export const CloseToggle = styled(Toggle)`
  position: absolute;
`
export const ButtonHolder = styled.div`
  z-index: 999000000;
  position: absolute;
  /* border: white solid 2px; */
  top: 1rem;
  right: 1rem;
  z-index: 1;
  display: grid;
  grid-template-columns: ${({ role }) => `repeat(${role === "sender" ? "3" : "1"}, 60px)`};
  /* gap: 20; */
  grid-gap: 20px;
`

export const NavMenuHolder = styled.div`
  position: fixed;
  z-index: 9999;
  top: ${({ isopen }) => (isopen ? "0" : "100vh")};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  transition: top 0.3s ease;
  background-color: ${({
    theme: {
      palette: { menuBG }
    }
  }) => menuBG};
  color: ${({
    theme: {
      palette: { menuFG }
    }
  }) => menuFG};
`
